var CollectionView = require('views/base/collection-view');
var View = require('views/base/view');

var GroupCollectionView = CollectionView.extend({
  autoRender: true,
  template: require('./templates/group-collection'),
  itemView: require('./group-item-view'),
  listSelector: '.group-items',
  animationDuration: 0,
  initItemView: function(model) {
    return new this.itemView({
      autoRender: false,
      model: model,
      groupPage: this.model.get('group_page'),
      groupTemplate: this.model.get('group_template')
    });
  },
  getTemplateData: View.prototype.getTemplateData
});

module.exports = GroupCollectionView;
